module.exports = __webpack_public_path__ + "media/images/bg/mosaic/drum-8c2a6b46baeca87bb3079864e7452507.jpg";